const state = () => ({
  currentMenu: '', //현재 메뉴
  isLock: false, //메뉴 제어 잠금
  currentMenuTitle: '', // 현재 메뉴명(한국어명)
  currentMenuTitleEn: '', // 현재 메뉴명(영문명)
});

const getters = {
  getCurrentMenu: state => state.currentMenu,
  getIsLock: state => state.isLock,
  getCurrentMenuTitle: state => state.currentMenuTitle,
  getCurrentMenuTitleEn: state => state.currentMenuTitleEn,
};

const actions = {
  // 현재 메뉴 저장하기
  setCurrentMenu({ commit }, currentMenu) {
    commit('SET_CURRENT_MENU', currentMenu);
  },
  setIsLock({ commit }, isLock) {
    commit('SET_IS_LOCK', isLock);
  },
  setCurrentMenuTitle({ commit }, currentMenuTitle) {
    commit('SET_CURRENT_MENU_TITLE', currentMenuTitle);
  },
  setCurrentMenuTitleEn({ commit }, currentMenuTitleEn) {
    commit('SET_CURRENT_MENU_TITLE_EN', currentMenuTitleEn);
  },
};

const mutations = {
  SET_CURRENT_MENU(state, payload) {
    state.currentMenu = payload;
  },
  SET_IS_LOCK(state, payload) {
    state.isLock = payload;
  },
  SET_CURRENT_MENU_TITLE(state, payload) {
    state.currentMenuTitle = payload;
  },
  SET_CURRENT_MENU_TITLE_EN(state, payload) {
    state.currentMenuTitleEn = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
